function handleSearch() {
	var search = document.getElementById('js-search');
	var searchTrigger = document.querySelectorAll('.search-trigger');
	var body = document.body;

	searchTrigger.forEach(function (el) {
		el.addEventListener('click', function (e) {
			e.preventDefault();
			search.classList.toggle('is-open');
			body.classList.toggle('overflow-hidden');
		});
	});
}

handleSearch();
